import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import swal from "sweetalert";
import "./DeleteAccount.css";

function DeleteAccount({ onDelete }) {
    const [phone, setPhone] = useState("");
    const [loading, setLoading] = useState(false);

    const validatePhone = (p) => {
        const digits = p.replace(/\D/g, "");
        return digits.length >= 9;
    };

    const handleDelete = async (e) => {
        e.preventDefault();
        if (!phone) {
            swal("Missing Field", "Enter your phone number", "warning");
            return;
        }
        if (!validatePhone(phone)) {
            swal("Invalid Phone", "Enter a valid phone number", "warning");
            return;
        }

        const confirmed = await swal({
            title: "Delete account",
            text: "This will permanently delete your account. This action cannot be undone. Continue?",
            icon: "warning",
            buttons: ["Cancel", "Delete"],
            dangerMode: true
        });

        if (!confirmed) return;

        try {
            setLoading(true);
            // If parent provided onDelete, call it with phone
            // onDelete should perform actual deletion and return a promise
            if (onDelete && typeof onDelete === "function") {
                await onDelete(phone);
            } else {
                // placeholder for deletion logic
                // replace with API call or Firebase logic
                await new Promise(res => setTimeout(res, 1200));
            }

            swal("Deleted", "Your account has been deleted", "success");
            setPhone("");
        } catch (err) {
            console.error(err);
            swal("Error", err?.message || "Could not delete account", "error");
        } finally {
            setLoading(false);
        }


    };

    return (
        <main className="delete-page">
            <div className="delete-orb delete-orb-one" />
            <div className="delete-orb delete-orb-two" />

            <section className="delete-shell">
                <header className="delete-hero">
                    <p className="delete-eyebrow">Account controls</p>
                    <h1>Delete your account</h1>
                    <p className="delete-lead">
                        This process permanently removes your account, delivery history,
                        and saved preferences. Please confirm your phone number to proceed.
                    </p>
                </header>

                <div className="delete-grid">
                    <div className="delete-card">
                        <Form onSubmit={handleDelete}>
                            <Form.Group className="delete-form-group">
                                <Form.Label className="delete-label">Phone number</Form.Label>
                                <Form.Control
                                    className="delete-input"
                                    type="tel"
                                    placeholder="e.g. 0712345678"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    inputMode="tel"
                                    required
                                />
                                <p className="delete-hint">We use this to confirm account ownership.</p>
                            </Form.Group>

                            <div className="delete-actions">
                                <Button
                                    className="delete-btn"
                                    variant="danger"
                                    type="submit"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <Spinner as="span" animation="border" size="sm" className="me-2" />
                                            Deleting account...
                                        </>
                                    ) : (
                                        "Delete my account"
                                    )}
                                </Button>
                            </div>
                        </Form>

                        <p className="delete-note">
                            This action cannot be undone. If you are the account owner and
                            still want to proceed, confirm your phone number above.
                        </p>
                    </div>

                    <aside className="delete-side">
                        <div className="delete-panel delete-panel-warning">
                            <h3>Before you delete</h3>
                            <ul className="delete-list">
                                <li>Outstanding deliveries must be completed or cancelled first.</li>
                                <li>Invoices and receipts will be removed from your portal.</li>
                                <li>Any saved addresses and preferences will be erased.</li>
                            </ul>
                        </div>

                        <div className="delete-panel">
                            <h3>Need help instead?</h3>
                            <p>
                                Contact support if you have billing questions, want to pause
                                your account, or need help exporting records before deletion.
                            </p>
                            <p className="delete-support">support@dropoffmtaani.com</p>
                        </div>
                    </aside>
                </div>
            </section>
        </main>
    );
}

export default DeleteAccount;
